import { Component, EventEmitter, Inject, Input, Output } from 'ng-metadata/core';
type bannerType = 'info' | 'alert';

/**
 * @ngdoc directive
 * @name mwBanner
 * @module mw.components.banner
 *
 * @description
 * The banner component displays an important, succinct message, and provides action buttons for users
 * to address (or dismiss the banner).  It requires a user action to be dismissed.
 *
 * @param {function} [on-close] - A function you want to have called when the banner is closed out
 * @param {string} [type] - Controls the visualization of the banner.  Supported types include 'info' and 'alert'
 * @param {boolean} [is-close-visible] - Boolean to decide whether or not the banner close button will be visible
 *
 * @usage
 * <hljs hljs-language="html">
 *  <mw-banner on-close="$ctrl.onClose($event)">
 *      <h1> Here is a wonderful banner! </h1>
 *      <mw-banner-actions>
 *          <md-button class="mw-button mw-button--link md-primary" ng-click="$ctrl.customAction()">custom action</md-button>
 *      </mw-banner-actions>
 *      <mw-banner-close>
 *          <mw-icon-button ng-click="$ctrl.customClose($event)" svg-icon="navigation:ic_close_24px"></mw-icon-button>
 *      </mw-banner-close>
 * </mw-banner>
 * </hljs>
 */
@Component({
    selector: 'mw-banner',
    template: `
        <div class="mw-banner md-whiteframe-z1 md-whiteframe-dp1" ng-class="['mw-banner--'+$ctrl.type, {'mw-banner--has-close': $ctrl.isCloseVisible}]">
            <div class="mw-banner__content" layout="row" layout-nowrap>
                <div class="mw-banner__icon-wrapper">
                    <mw-icon ng-if="$ctrl.type === 'info'" svg-icon="action:ic_info_outline_24px"></mw-icon>
                    <mw-icon ng-if="$ctrl.type === 'alert'" svg-icon="alert:ic_error_24px" class="mw-banner__icon-alert"></mw-icon>
                </div>
                <ng-transclude flex class="mw-banner__text-content"></ng-transclude>
                <ng-transclude ng-transclude-slot="mwBannerClose" ng-if="$ctrl.isCloseVisible">
                    <mw-icon-button ng-click="$ctrl.closeBanner($event)" svg-icon="navigation:ic_close_24px" hover="true" class="mw-banner__close"></mw-icon-button>
                </ng-transclude>
            </div>
            <div class="mw-banner__footer" ng-transclude="mwBannerActions"></div>
        </div>
    `,
    legacy: {
        transclude: {
            mwBannerActions: '?mwBannerActions',
            mwBannerClose: '?mwBannerClose'
        }
    }
})
export class BannerComponent {
    @Input('<') isCloseVisible: boolean = true;
    @Input('<') type: bannerType = 'info';
    @Output() onClose = new EventEmitter();

    constructor() {
    }

    closeBanner(event) {
        this.onClose.emit({event});
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/banner/banner.component.ts